import React from "react";
import TablaSucursalBeneficio from "js/components/TablaSucursalBeneficio";

function SucursalBeneficio(props) {
  return <TablaSucursalBeneficio />;
}

export default SucursalBeneficio;
